<template>
  <Dialog
      :header="t('DETAILS')"
      v-model:visible="visible"
      modal
      :draggable="false"
      :dismissable-mask="true"
      class="enrolment-details-modal"
  >
    <div>
      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("NAME") }}</div>
        <div class="col-sm-12 details-value">{{ enrolment.trainee?.fullName }}</div>
      </div>

      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("SSN") }}</div>
        <div class="col-sm-12 details-value">{{ enrolment.trainee?.ssn }}</div>
      </div>

      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("PHONE") }}</div>
        <div class="col-sm-12 details-value">{{ enrolment.trainee?.phone || "-" }}</div>
      </div>

      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("EMAIL") }}</div>
        <div class="col-sm-12 details-value">{{ enrolment.trainee?.email || "-" }}</div>
      </div>

      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("CITIZENSHIPS") }}</div>
        <div class="col-sm-12 details-value">
          <citizenship-list :citizenships="enrolment.trainee?.citizenships"/>
        </div>
      </div>

      <div class="row details-row">
        <div class="col-sm-12 details-title">{{ t("EXPECTATIONS") }}</div>
        <div class="col-sm-12 details-value">{{ enrolment.expectations || "-" }}</div>
      </div>
    </div>

    <template #footer>
      <Button :label="t('CLOSE')" @click="visible = false"/>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {ref} from "vue";
import type {EnrolmentDto} from "@/model/enrolment";
import CitizenshipList from "@/views/components/CitizenshipList.vue";

const {t} = useI18n();

const visible = ref(false);
const enrolment = ref<Partial<EnrolmentDto>>({});

const openModal = (enrolmentVal: EnrolmentDto) => {
  enrolment.value = enrolmentVal;
  visible.value = true;
};

defineExpose({
  openModal,
});

</script>

<style scoped lang="scss">
.details-row {
  margin-bottom: 0.5rem;

  & > .details-title {
    font-size: 1.4rem;
    margin-bottom: 0.5rem;
    color: var(--p-color-blue-600);
  }

  & > .details-value {
    padding-left: 1.5rem;
    white-space: break-spaces;
  }
}
</style>
